export default {
    mapGeofenceCreateEditGeofenceGroup_editTitle: "Editar Grupo de Geocerca: ",
    mapGeofenceCreateEditGeofenceGroup_createTitle: "Crear Nuevo Grupo de Geocerca",
    mapGeofenceCreateEditGeofenceGroup_name: "Nombre",
    mapGeofenceCreateEditGeofenceGroup_success: "Grupo de Geocerca guardado",
    mapGeofenceCreateEditGeofenceGroup_iconRequired: 'Debe seleccionar un ícono o deshabilitar el switch de "Ícono de Grupo Geocerca", por favor intente de nuevo',
    mapGeofenceCreateEditGeofenceGroup_groupAlreadyExists: "Ya existe un grupo con el nombre ingresado"
};